import React from 'react';
import { useShipmentLegNumbers } from './api';
import { useHistory } from 'react-router-dom';
import { LegNavigation } from './LegNavigation';
export const LegNumberSummary = ({ id }) => {
    var _a;
    const { data: legs = [] } = useShipmentLegNumbers({
        id,
    });
    const totalLegs = legs.length;
    const history = useHistory();
    const currentLeg = legs.find((leg) => leg._id === id);
    const currentLegNumber = (_a = currentLeg === null || currentLeg === void 0 ? void 0 : currentLeg.leg_number) !== null && _a !== void 0 ? _a : 1;
    function handleCurrentLegChange(legNumber) {
        const leg = legs.find((leg) => leg.leg_number === legNumber);
        if (leg) {
            history.push(`/shipments/${leg._id}`);
        }
    }
    return (React.createElement(LegNavigation, { currentLeg: currentLegNumber, totalLegs: totalLegs, onLegChange: handleCurrentLegChange }));
};
